import axios from 'axios';

const BASE_HOST_API = process.env.GATSBY_APP_API_URL;
const EMAIL_SUBSCRIBE_API = `${BASE_HOST_API}/email/subscribe`;

const subscribeEmail = async email => {
  try {
    const response = await axios.post(EMAIL_SUBSCRIBE_API, { email });

    if (response.data && response.data.success) {
      return response.data;
    }

    return Promise.reject(new Error('Failure'));
  } catch (error) {
    return Promise.reject(error);
  }
};

export default subscribeEmail;
